import { styled, Typography } from '@mui/material';

function TransferDetails() {
    return (
        <EncartContainer>
            <EncartContent>
                <FullWidthCenteredColumn>
                    <Title>COORDONNÉES BANCAIRES</Title>
                    <Typography>Bénéficiaire : ÉCOLE SUPÉRIEURE D'ARCHITECT. DE ESAJ</Typography>
                    <Typography>IBAN : FR76 4255 9100 0008 0240 8553 089</Typography>
                    <Typography>BIC : CCOPFRPPXXX</Typography>
                </FullWidthCenteredColumn>
            </EncartContent>
        </EncartContainer>
    );
}

const EncartContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
}));
const EncartContent = styled('div')(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    border: `1px dashed ${theme.palette.common.black}`,
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}));
const FullWidthCenteredColumn = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
}));
const Title = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    marginBottom: theme.spacing(2),
}));

export { TransferDetails };
